import { FormState, Radio, RadioGroup } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { SubscriptionType } from 'typings'
import { GroupLabel } from '../../../../GroupLabel'
import { RadioDescription } from '../../../../Radio/RadioDescription'
import { messages } from '../messages'
import { styles } from '../styles'

type Props = {
  name: string
  state: FormState
}

export function TypeInput(props: Props) {
  const { name, state } = props

  const { $t } = useIntl()

  return (
    <RadioGroup
      name={name}
      state={state}
      label={<GroupLabel>{$t(messages.type.label)}</GroupLabel>}
      className={styles.radioGroup}
    >
      {Object.values(SubscriptionType).map((value) => (
        <Radio
          key={value}
          aria-label={$t(messages.type[value].label)}
          label={
            <RadioDescription
              title={$t(messages.type[value].label)}
              description={$t(messages.type[value].description)}
            />
          }
          value={value}
        />
      ))}
    </RadioGroup>
  )
}
